import Slice from './slice';
import { CountryType } from '../../models/countryUnitActuals';

export type SelectedActionType = {
  type: string;
  payload: string;
};

export const selectCountryCodes = Slice.actions.selectCountryCodes as (
  payload: CountryType[],
) => SelectedActionType;
